import { createReducer } from 'src/helpers/reducer';
import actionTypes from './actionTypes';
import type { IGateCondition } from '../sharedTypes';
import type { IContractMutationsState } from './types';

const initState: IContractMutationsState = {
  isInviting: false,
  inviteGateConditions: [],
  inviteError: null,
  isRemoving: false,
  removeError: null,
};

type MessagePayload = { payload: { message: string } };

export default createReducer(initState, {
  [actionTypes.INVITE_REQUEST]: (state: IContractMutationsState) => ({
    ...state,
    isInviting: true,
    inviteGateConditions: [],
    inviteError: null,
  }),
  [actionTypes.INVITE_SUCCESS]: (state: IContractMutationsState) => ({
    ...state,
    isInviting: false,
    inviteGateConditions: [],
    inviteError: null,
  }),
  [actionTypes.INVITE_GATE_FAILED]: (
    state: IContractMutationsState,
    { payload }: { payload: { conditions: IGateCondition[] } },
  ) => ({ ...state, isInviting: false, inviteGateConditions: payload.conditions, inviteError: null }),
  [actionTypes.INVITE_ERROR]: (state: IContractMutationsState, { payload }: MessagePayload) => ({
    ...state,
    isInviting: false,
    inviteGateConditions: [],
    inviteError: payload.message,
  }),
  [actionTypes.REMOVE_REQUEST]: (state: IContractMutationsState) => ({
    ...state,
    isRemoving: true,
    removeError: null,
  }),
  [actionTypes.REMOVE_SUCCESS]: (state: IContractMutationsState) => ({
    ...state,
    isRemoving: false,
    removeError: null,
  }),
  [actionTypes.REMOVE_ERROR]: (state: IContractMutationsState, { payload }: MessagePayload) => ({
    ...state,
    isRemoving: false,
    removeError: payload.message,
  }),
  [actionTypes.CLEAR_STORE]: () => initState,
});
